import { useContext, useEffect } from 'react';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import ConditionalTileContext from '~/contexts/ConditionalTileContext';
import { useFinanceInfo } from '~/contexts/FinanceAndTradeContext';

export default function useFilteredByMinDown() {
  const {
    appliedFilters: { finance: financeFilters }
  } = useContext(AppliedFiltersContext);
  const { setFilteredByMinDown } = useContext(ConditionalTileContext);
  const financeInfo = useFinanceInfo();

  useEffect(() => {
    setFilteredByMinDown(
      financeFilters?.downPayment == null
        ? false
        : financeFilters?.downPayment === financeInfo?.minDownPayment
    );
  }, [
    financeFilters?.downPayment,
    financeInfo?.minDownPayment,
    setFilteredByMinDown
  ]);
}
